// QR stickers (Echipamente → „Imprimă etichete”, Inventariere).
// The QR code always points at the production address, also when printing from a local or beta copy:
// a sticker lives on the device for years. Change it here only if the app moves to another address.
export const STICKER_ORIGIN = "https://suport.usarb.md";

// https://suport.usarb.md/e/AB3K7MQZ → the item card (route /e/:tag)
export function stickerUrl(tag) {
  return `${STICKER_ORIGIN}/e/${tag}`;
}

// The in-app link to an item's card (same tag)
export function itemCardPath(tag) {
  return `/e/${tag}`;
}
